import React, { useEffect, useState } from "react";
import CreateScrimRules from "./CreateScrimRules";
import { TextField } from "@mui/material";
import { useScrimContext } from "./CreateScrimContextAPI";
import CategoryDropDown from "../../CustomerCare/CategoryDropDown";
import { scrimGameType, scrimGameCreate, scrimById } from "../../../api/scrim.api";
import DateTimePopup from "../../Popup/DateTimePopup";
import { useTranslation } from "react-i18next";
import {
  generateAMPM,
  generateArrayOfYears,
  generateHours,
  generateMinutes,
  generateMonths,
  generateNumberArray,
} from "../../Popup/Utils";
import TimePopup from "../../Popup/TimePopup";
import Button from "../../CommonFields/Button";
import TimePicker from "./TimePicker";
import DatePicker from "./DatePicker";
import { toast } from "react-toastify";
import { resolvePath } from "react-router";
import { toastError, toastSuccess } from "../../../Utilities/toast";
import moment from "moment";

const CreateScrimDetails = ({ id, setValue, setScrimData, setScrimValid, triggerValidation, setTriggerValidation }) => {
  const [currencyId, setCurrencyId] = useState([]);
  const { t } = useTranslation();
  const { data } = useScrimContext();
  const [contestName, setContestName] = useState("");
  const [noOfPlayers, setNoOfPlayers] = useState("");
  const [noOfWinners, setNoOfWinners] = useState("");
  const [GameId, setGameId] = useState([]);
  const [GametypeId, setGametypeId] = useState('');
  const [defaultGametypeId, setDefaultGametypeId] = useState([]);
  const [title1, setTitle1] = useState("");

  const [nameError, setNameError] = useState("");
  const [dateError, setDateError] = useState("");
  const [timeError, setTimeError] = useState("");
  const [noOfPlayerError, setNoOfPlayerError] = useState("");
  const [noOfWinnerError, setNoOfWinnersError] = useState("");
  const [gameTypeError, setGameTypeError] = useState("");
  const [gameTypeTitleError, setGameTypeTitleError] = useState("");

  const [titleError, setTitle1Error] = useState("");
  const [title1Values, setTitle1Values] = useState([]);
  const [title2Values, setTitle2Values] = useState([]);
  const [defaulttitle1Values, setdefaultTitle1Values] = useState([{}]);
  const [defaulttitle2Values, setdefaultTitle2Values] = useState([{}]);
  const [title2, setTitle2] = useState("");
  const [showTitleDropDown, setShowTilteDropDown] = useState(false);
  const [showTitle1DropDown, setShowTilte1DropDown] = useState(false);
  const [showDatePopup, setShowDatePopup] = useState(false);
  const [showTimePopup, setShowTimePopup] = useState(false);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [gameTypes, setGameTypes] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [mapValues, setMapValues] = useState([]);
  const [type, setType] = useState([]);
  const [feesss, setFeess] = useState([]);

  const [defaultType, setDefaultType] = useState([]);

  let tyear = new Date().getFullYear();
  let month = ("0" + (new Date().getMonth() + 1)).slice(-2);
  let day = ("0" + new Date().getDate()).slice(-2);
  const todayDate = day + "/" + month + "/" + tyear;
  const getDate = (date) => {
    setDate(date);
    if (date !== '') {
      setDateError('')
    }
    setShowDatePopup(false);
  };
  const getTime = (time) => {
    setTime(time);
    if (time !== '') {
      setTimeError('')
    }
    setShowTimePopup(false);
  };

  const showDateandTime = () => {
    setShowDatePopup(false);
    setShowTimePopup(false);
  };

  const formatDateString = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatTimeString = (isoString) => {
    const date = new Date(isoString);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${String(hours).padStart(2, "0")}:${minutes} ${period}`;
  };

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("scrimDetails"));
    //console.log("savedData",savedData)
    if (savedData) {
      setContestName(savedData.title || "");
      setNoOfPlayers(savedData.noOfPlayerCapacity || "");
      setNoOfWinners(savedData.noOfWinner || "");
      setDate(savedData.date ? formatDateString(savedData.date) : "");
      setTime(savedData.time ? formatTimeString(savedData.time) : "");
      setTitle1(savedData?.title1?.value || "");
      setTitle2(savedData?.title2?.value || "");
      //console.log(savedData?.selectedFieldFromGameTitles)
      if (savedData?.selectedFieldFromGameTitles !== null) {
        var data = gameTypes.findIndex((element) => element?.name === savedData?.type)
        setSelectedFieldGameTitles(savedData?.selectedFieldFromGameTitles)
        setGameTitleFields(savedData?.dropdownFieldGameType)
      }
    }
  }, [defaultGametypeId]);

  useEffect(() => {
    const savedGameType = JSON.parse(localStorage.getItem("selectedGameType"));
    if (savedGameType) {
      const index = gameTypes.findIndex(
        (type) => type._id === savedGameType._id
      );
      if (index !== -1) {
        // setActiveIndex(index);
        setType(savedGameType.name);
        setGametypeId(savedGameType._id);
        setTitle1Values(savedGameType.game.title1Values);
        setTitle2Values(savedGameType.game.title2Values);
      }
      const savedData = JSON.parse(localStorage.getItem("scrimDetails"));

      var data = gameTypes.findIndex((element) => element?.name === savedData?.type)
      setActiveIndex(data)
    }
  }, [gameTypes]);
  useEffect(() => {
    if (triggerValidation) {
      handleNext()
      setTriggerValidation(false)
    }


  }, [triggerValidation])
  useEffect(() => {
    const fetchGameTypes = async () => {
      try {
        const gameId = localStorage.getItem("activeGameId");
        setGameId(gameId);
        const data = {
          filter: {
            game: `${gameId}`,
          },
        };

        const response = await scrimGameType(data);

        console.log("SCRIM-HOST-SETTINGS",response.data);
        const names = response.data;
        setGameTypes(names);
        var titles = names[0]?.game?.titles;
        var tempFieldArray = [];
        titles.map((item) => {
          tempFieldArray.push({
            selectedTitle: {},
            dropdownList: [],
            selectedTitleValue: {}
          })
        })
        
        setSelectedFieldGameTitles(titles);

        setDefaultGametypeId(names[0]._id);
        setDefaultType(names[0].name);

        const fees = response.hostSettings.hostFees;
        setFeess(fees);
        localStorage.setItem("hostSettingCurrency", JSON.stringify(response?.hostSettings?.currency[0] || null));

        const currency_id = response?.hostSettings?.currency[0]._id;
        // //console.log(response?.hostSettings?.currency[0]._id);
        setCurrencyId(currency_id);

        // const maps= response.data.map(item=>item.game)
        // const maptitles= maps.map(item=>item.title1Values)

        // //console.log("API Response:", names);
        const defaul_map_values = names[0].game.title1Values;

        setdefaultTitle1Values(defaul_map_values);

        // //console.log(names[0].game.title2Values);
        const defaul_perspective_values = names[0].game.title2Values;

        setdefaultTitle2Values(defaul_perspective_values);
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchGameTypes();
  }, []);
  const [selectedFieldFromGameTitles, setSelectedFieldGameTitles] = useState([]);
  const [activeDropdownTitleObject, setActiveDropdownTitleObject] = useState(null);
  const [popupIndex, setPopupIndex] = useState(0);
  const [dropdownFieldGameType, setGameTitleFields] = useState(null)
  const [dynamicDropdownList, setDynamicDropdownList] = useState([])
  const [showDynamicPopup, setDynamicPopup] = useState(false);
  const onGameTitleSelect = (title) => {
    var dataList = [...selectedFieldFromGameTitles];
    var isAlreadyExist = dataList?.find((e) => e?.selectedTitle?.value === activeDropdownTitleObject?.value)
    var isExistIndex = dataList?.findIndex((e) => e?.selectedTitle?.value === activeDropdownTitleObject?.value)
    //console.log("isAlreadyExist",isAlreadyExist)
    if (isAlreadyExist) {
      dataList[isExistIndex].selectedTitle = activeDropdownTitleObject
      dataList[isExistIndex].dropdownList = dynamicDropdownList
      dataList[isExistIndex].selectedTitleValue = dynamicDropdownList.find((element) => element?.value === title)
    } else {
      dataList[popupIndex] ={
        selectedTitle: activeDropdownTitleObject,
        dropdownList: dynamicDropdownList,
        selectedTitleValue: dynamicDropdownList.find((element) => element?.value === title)
      };
    }
    setSelectedFieldGameTitles(dataList)
    setTitle2(title);
    setDynamicPopup(false);
  };
  const handleClick = (index, type) => {
    setActiveIndex(index);
    setType(type.name);
    setGametypeId(type._id);
    localStorage.setItem("selectedGameType", JSON.stringify(type));
    const map_values = type.game.title1Values;
    const perspective_values = type.game.title2Values;
    setGameTitleFields(type.game);
    setTitle1Values(map_values);
    setTitle2Values(perspective_values);
    setGameTypeError('')
  };

  const handleNext = async () => {
    var isAllValid = true
    if (contestName == null || contestName?.trim() === '') {
      setNameError("enter contest name")
      isAllValid = false
    }
    //console.log(GametypeId)
    if (GametypeId == null || GametypeId?.trim() === '') {
      setGameTypeError('select game type ')
      isAllValid = false
    }
    if (date == null || date?.trim() === '') {
      setDateError('select date')
      isAllValid = false
    }
    setGameTypeTitleError('select game')
    if (time == null || time?.trim() === '') {
      setTimeError('select time')
      isAllValid = false
    }
    //console.log(noOfPlayers)
    if (noOfPlayers == null || noOfPlayers === '') {
      setNoOfPlayerError('enter players')
      isAllValid = false
    }
    if(noOfPlayers <= 0) {
      console.log("i m here 2")
      setNoOfPlayerError(t('private_contest.please_enter_valid_number_of_players'))
      isAllValid = false
    }
    if (noOfWinners == null || noOfWinners === '') {
      setNoOfWinnersError('enter winners')
      isAllValid = false
    }
    if(noOfWinners <= 0) {
      setNoOfWinnersError(t('private_contest.please_enter_valid_number_of_winners'))
      isAllValid = false
    }
    if (parseInt(noOfWinners) >= parseInt(noOfPlayers)) {
      setNoOfWinnersError('No of winner should be less then no of players')
      isAllValid = false
    }

    var isInValid = false;
    if (selectedFieldFromGameTitles === null || selectedFieldFromGameTitles?.length === 0) {
      isInValid = true;
    } else {
      selectedFieldFromGameTitles.forEach((selectedTitleObject, index) => {
        if (selectedTitleObject == null) { isInValid = true }
        else if (selectedTitleObject.selectedTitleValue === null) { isInValid = true }
        else { isInValid = false }
      })
    }
    if (isInValid) {
      setGameTypeTitleError('select game titles')
      isAllValid = false
    }
    if (isAllValid === false) {
      setScrimValid(false);
      return
    }






    const [day, month, year] = date.split("/");
    const [timePart, period] = time.split(" ");
    const [hours, minutes] = timePart.split(":");

    // Convert 12-hour time to 24-hour time
    let hourIn24 = parseInt(hours, 10);
    if (period === "PM" && hourIn24 < 12) {
      hourIn24 += 12;
    } else if (period === "AM" && hourIn24 === 12) {
      hourIn24 = 0;
    }

    // Create a Date object
    const combinedDateTime = new Date(
      Date.UTC(
        parseInt(year, 10),
        parseInt(month, 10) - 1,
        parseInt(day, 10),
        hourIn24,
        parseInt(minutes, 10),
        0
      )
    );

    if (isNaN(combinedDateTime.getTime())) {
      console.error("Invalid date created:", combinedDateTime);
      return;
    }
    var enewdate = handleDateSave(date, time);
    const scrimDate = moment(date, "DD/MM/YYYY");
    var currentDate = moment();
    if (scrimDate.isBefore(currentDate, 'day')) {
      setDateError('enter future date')
      return
    }
    currentDate = moment().add(15, "minutes");
    const scrimTime = moment(time, "hh:mm A")
    const combinedScrimDateTime = scrimDate.set({
      hour: scrimTime.hour(),
      minute: scrimTime.minute(),
      second: 0,
      millisecond: 0
    });

    //console.log(moment(currentDate).format("DD/MM/YYYY hh:mm A"))
    //console.log(moment(combinedScrimDateTime).format("DD/MM/YYYY hh:mm A"))
    //console.log(combinedScrimDateTime.isBefore(currentDate, 'minute'))
    if (combinedScrimDateTime.isBefore(currentDate)) {
      setTimeError('select future time')
      return
    }
    var payload = {
      title: contestName,
      date: enewdate,
      time: enewdate,
      noOfPlayerCapacity: noOfPlayers,
      noOfWinner: noOfWinners,
      feeAmount: feesss,
      type: type ? type : defaultType,
      game: GameId,
      gameType: GametypeId ? GametypeId : defaultGametypeId,
      currency: currencyId,
      selectedFieldFromGameTitles: selectedFieldFromGameTitles,
      dropdownFieldGameType: dropdownFieldGameType,
      platform: "web"
    };
    selectedFieldFromGameTitles.forEach((selectedTitleObject, index) => {
      var object = { ['title' + (index + 1)]: { name: selectedTitleObject?.selectedTitle?.value, value: selectedTitleObject?.selectedTitleValue?.value } }
      payload = { ...payload, ...object }
    })
    //console.log(selectedFieldFromGameTitles)
    localStorage.setItem("scrimDetails", JSON.stringify(payload));
    setScrimValid(true);
    setScrimData(payload);
    if (setScrimData) {
      setValue(1);
    }
  };
  const handleDateSave = (formattedDate, time) => {
    const [day, month, year] = formattedDate.split("/");
    const paddedDay = day.padStart(2, '0'); // Add leading zero if needed
    const paddedMonth = month.padStart(2, '0'); // Add leading zero if needed
    const formatted = `${paddedDay}-${paddedMonth}-${year}`; // Convert to "dd-mm-yyyy"

    const [timePart, period] = time.split(" ");
    const [hours, minutes] = timePart.split(":");

    // Convert 12-hour time to 24-hour time
    let hourIn24 = parseInt(hours, 10);
    if (period === "PM" && hourIn24 < 12) {
      hourIn24 += 12;
    } else if (period === "AM" && hourIn24 === 12) {
      hourIn24 = 0;
    }
    return new Date(`${year}-${paddedMonth}-${paddedDay} ${hourIn24}:${minutes}:00`)

  };
  function fetchDynamicValues(selectedTitle) {
    const valuesKey = "title" + selectedTitle + "Values";  // e.g., "title1Values"
    //console.log(valuesKey)
    //console.log(dropdownFieldGameType[valuesKey])
    if (dropdownFieldGameType[valuesKey]) {
      return dropdownFieldGameType[valuesKey];
    } else {
      return [];
    }
  }
  const handleInputChange = (e) => {
    let value = e;
    if (value.length <= 64) {
      setContestName(value);
    }
    if (e !== '') {
      setNameError('')
    }
  };


  useEffect(() => {
    if (gameTypes && id) {
      const fetchScrimById = async () => {
        try {
          const response = await scrimById({
            id: id
          });
          const savedData = response.data
          if (savedData) {
            setContestName(savedData.title || "");
            setNoOfPlayers(savedData.noOfPlayerCapacity || "");
            setNoOfWinners(savedData.noOfWinner || "");
            setDate(savedData.date ? formatDateString(savedData.date) : "");
            setTime(savedData.time ? formatTimeString(savedData.time) : "");
            setTitle1(savedData?.title1?.value || "");
            setTitle2(savedData?.title2?.value || "");
            var findSelectedGameType = gameTypes?.find((element) => element?._id === savedData?.gameType?._id)
            var findSelectedIndex = gameTypes?.findIndex((element) => element?._id === savedData?.gameType?._id)
            if (findSelectedGameType) {
              setActiveIndex(findSelectedIndex);
              setType(findSelectedGameType.name);
              setGametypeId(findSelectedGameType._id);
              localStorage.setItem("selectedGameType", JSON.stringify(findSelectedGameType));
              const map_values = findSelectedGameType.game.title1Values;
              const perspective_values = findSelectedGameType.game.title2Values;
              setGameTitleFields(findSelectedGameType.game);
              setTitle1Values(map_values);
              setTitle2Values(perspective_values);
              setGameTypeError('')

              let selectedTypeArray = []
              // //console.log("savedData?.titles",savedData?.titles)
              // //console.log("findSelectedGameType",findSelectedGameType)
              savedData?.titles.forEach((item) => {
                var selectedTitleIndex = findSelectedGameType?.game?.titles?.findIndex((element) => element?.name === item?.name)
                var dropdownList = findSelectedGameType.game[`title${selectedTitleIndex + 1}Values`];
                var selectedTitle = findSelectedGameType?.game?.titles?.find((element) => element?.name === item?.name)
                // //console.log("item", item)
                // //console.log("dropdownList", dropdownList)
                // //console.log("selectedTitle", selectedTitle)
                selectedTypeArray.push(
                  {
                    selectedTitle: selectedTitle,
                    dropdownList: dropdownList,
                    selectedTitleValue: dropdownList.find((elemnt) => elemnt?.value === item.value)
                    //  dropdownList.find((element) => element?.value === item?.name)
                  }
                )
              })
              // //console.log(selectedTypeArray)
              setSelectedFieldGameTitles(selectedTypeArray) // set selected field
              // selectedFieldFromGameTitles[index]?.selectedTitleValue

            }
          }
        } catch (error) {
          console.error("API Error:", error);
        }
      };

      fetchScrimById();
    }
  }, [gameTypes])
  useEffect(() => {
    //console.log("dynamicDropdownList", dynamicDropdownList)
  }, [dynamicDropdownList])

  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDateString(today); 
    const formattedTime = today.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    setDate(formattedDate);
    setTime(formattedTime);
  }, []);

  return (
    <>
      <div>
        <div className="mb-1-8 mt-4">
          <TextField
            id="contest-name"
            label={t("private_contest.contest_name")} // Added asterisk for required indication
            placeholder={t("private_contest.enter_contest_name")}
            value={contestName}
            onChange={(e) => handleInputChange(e.target.value)}
            autoComplete="off"
            helperText={nameError}
            required
          />
        </div>
        <div className="mb-1-8">
          <h4 className="text-center mb-4">{t("private_contest.select_scrim_type")}</h4>
          <div className="d-flex flex-wrap game-type-btn ">
            {gameTypes.map((type, index) => (
              <div
                key={index}
                className={`btn ${activeIndex === index ? "bg-red" : "bg-active"
                  } text-white`}
                onClick={() => handleClick(index, type)} // Set active on click
              >
                {type.name}
              </div>
            ))}
          </div>
          {
            gameTypeError !== '' && <div className="tournament-detail-value mt-2 ms-2" style={{ fontSize: "0.75rem", color: '#ee2737' }}>{gameTypeError}</div>
          }

        </div>
        {/* date and time */}
        <div className="d-flex gap-20" style={{ marginBottom: "2.2rem" }}>
      <TextField
        id="outlined-required-date"
        label={t("private_contest.select_date")}
        placeholder={date}
        onMouseDown={(e) => {
          e.preventDefault();
          setShowDatePopup(true);
        }}
        onChange={(e) => {
          if (dateError !== '') {
            setDateError('');
          }
          setDate(e.target.value); 
        }}
        value={date}
        helperText={dateError}
        autoComplete="off"
        required
      />
      <TextField
        id="outlined-required-time"
        label={t("private_contest.select_time")}
        placeholder={time}
        onMouseDown={(e) => {
          e.preventDefault();
          setShowTimePopup(true);
        }}
        onChange={(e) => {
          if (timeError !== '') {
            setTimeError('');
          }
          setTime(e.target.value); 
        }}
        value={time}
        helperText={timeError}
        autoComplete="off"
        required
      />
      {showDatePopup && (
        <DatePicker
          cancel={true}
          getDate={getDate}
          showDateandTime={showDateandTime}
          required
        />
      )}
      {showTimePopup && (
        <TimePicker
          cancel={true}
          getTime={getTime}
          getDate={date}
          todayDate={todayDate}
          todayTime={time}
          showDateandTime={showDateandTime}
          required
        />
      )}
    </div>

        {dropdownFieldGameType != null &&
          (
            <div className="d-flex gap-20" style={{ marginBottom: "2.3rem" }}>
              {dropdownFieldGameType?.titles?.map((element, index) => {
                // console.log("selectedFieldFromGameTitles", selectedFieldFromGameTitles)
                // console.log("selectedFieldFromGameTitles[index]", selectedFieldFromGameTitles[index]?.selectedTitleValue, index)
                return (<TextField
                  key={index}
                  id="outlined-required"
                  label={element?.value}
                  placeholder={element?.value}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    setPopupIndex(index)
                    setActiveDropdownTitleObject(element)
                    setDynamicDropdownList(fetchDynamicValues(index + 1))
                    setDynamicPopup(true);
                  }}
                  value={selectedFieldFromGameTitles[index]?.selectedTitleValue?.value || ""}
                  helperText={gameTypeTitleError !== "" ? selectedFieldFromGameTitles[index]?.selectedTitleValue == null || selectedFieldFromGameTitles[index]?.selectedTitleValue?.value === '' ? `select ${element?.value}` : '' : ''}
                  autoComplete="off"
                  required
                />)
              })}
            </div>
          )}


        {showDynamicPopup && (
          <CategoryDropDown
            cancel={true}
            getTitle={onGameTitleSelect}
            showDropDownValues={() => setDynamicPopup(false)}
            values={
              dynamicDropdownList?.length > 0
                ? dynamicDropdownList?.map((el) => el.value)
                : []
            }
            isOpen={showTitle1DropDown}
            title="Select map"
            required
          />
        )}
        <div className="d-flex gap-20">
          <TextField
            id="no-of-players"
            type="number"
            label={t("private_contest.number_of_players")}
            placeholder={t("private_contest.enter_number_of_players")}
            value={noOfPlayers}
            inputProps={{ min: 1 }}
            onChange={(e) => {
              setNoOfPlayers(e.target.value)
              if (noOfPlayerError !== '') { setNoOfPlayerError('') }
              if(e.target.value <= 0) {
                console.log("i m here")
                setNoOfPlayerError(t('private_contest.please_enter_valid_number_of_players'))
              }
            }}
            helperText={noOfPlayerError}
            autoComplete="off"
            required
          />

          <TextField
            id="no-of-winners"
            type="number"
            label={t("private_contest.number_of_winners")}
            placeholder={t("private_contest.enter_number_of_winners")}
            value={noOfWinners}
            inputProps={{ min: 1 }}
            onChange={(e) => {
              setNoOfWinners(e.target.value)
              if (noOfWinnerError !== '') { setNoOfWinnersError('') }
              if(e.target.value <= 0) {
                setNoOfWinnersError(t('private_contest.please_enter_valid_number_of_winners'))
              }
            }}
            autoComplete="off"
            helperText={noOfWinnerError}
            required
          />
        </div>
      </div>
      <div style={{ marginTop: "6rem" }}>
        <Button text={t("private_contest.next")} onClick={handleNext} />
      </div>
    </>
  );
};

export default CreateScrimDetails;
